import type { PackageFormValues } from './add-package.types';

export const packageFormDefaultValues: PackageFormValues = {
    productDetails: {
        name: '',
        description: '',
    },
    products: [
        {
            day_index: 1,
            items: [],
        },
    ],
    discount: {
        amount: 0,
        type: 'relative',
    },
    globalCurrency: '',
    assets: {
        images: [],
    },
    total: 0,
};
